import { Component, OnDestroy, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { EMPTY, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { SharedFeedbackService } from 'app/modules/feedback/services/shared-feedback.service';
import { CustomWindowService } from 'app/core/services/custom-window-service/custom-window.service';
import { FavoritenComponent } from 'app/core/layout/navbar/components/favoriten/favoriten.component';
import { I18nService } from 'app/core/services/i18n/i18n.service';
import { select, Store } from '@ngrx/store';
import { IAppState } from 'app/modules/shared-area/root-state';
import { SystemInfoActions, SystemInfoSelectors } from 'app/modules/shared-area/ducks/system-info/store';
import { AppRights } from 'app/core/utils/app-rights';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html'
})
export class NavbarComponent implements OnInit, OnDestroy {
  readonly Rights = AppRights;

  public runningMaintenanceWindow$: Observable<boolean> = EMPTY;

  public isSlim = false;

  public loggendInUser: string;
  public userManagementUrl = environment.userManagementUrl;
  public changePasswordUrl = environment.changePasswordUrl;
  public manageUserUrl = environment.manageUserUrl;
  public dataModelEditorUrl = environment.dataModelEditorUrl;
  public rechercheUrl = environment.rechercheUrl;

  private destroy$ = new Subject<void>();

  public ngOnInit() {
    this.runningMaintenanceWindow$ = this.store.pipe(select(SystemInfoSelectors.isMaintenanceWindowRunning));
    this.store.dispatch(SystemInfoActions.loadSystemInfo());
    
    this.oidcSecurityService.userData$
      .pipe(takeUntil(this.destroy$))
      .subscribe((userData: any) => {
        // Handle the nested structure - actual user data is in userData.userData
        const actualUserData = userData?.userData;
        
        if (actualUserData && actualUserData !== '') {
          this.loggendInUser =
            actualUserData.given_name && actualUserData.family_name
              ? actualUserData.given_name + ' ' + actualUserData.family_name
              : actualUserData.preferred_username;
        } else {
          // Optionally set a default or clear the user
          this.loggendInUser = '';
        }
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  constructor(
    private sharedFeedbackService: SharedFeedbackService,
    private windowService: CustomWindowService,
    private i18n: I18nService,
    private store: Store<IAppState>,
    public oidcSecurityService: OidcSecurityService,
  ) {
    this.onResize();
  }

  public onResize() {
    const width = document.body.clientWidth;
    if (width <= 990) {
      this.isSlim = true;
    } else {
      this.isSlim = false;
    }
  }

  public openCommonFeedback() {
    this.sharedFeedbackService.openCommonFeedbackDialog();
  }

  public openFavoriten() {
    this.windowService.open({
      type: 'favoriten',
      title: this.i18n.getLocalizedString('components.favoriten.title'),
      content: FavoritenComponent,
      width: 500
    });
  }

  public signOut() {
    this.oidcSecurityService.logoff()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          console.log('Logoff initiated');
        },
        error: (err) => {
          console.error('Logoff error', err);
        }
      });
  }
}
